import { useGetGuestsiteCoupleStoryAndQandasQuery } from './CoupleStory.graphql.generated';
import { useEventUserRole } from '@shared/components/AuthProvider';
import { useIsCurrentPageSsrFetchEnabled } from '@apps/guest/shared/hooks/useIsCurrentPageSsrFetchEnabled';
import { isInIframe } from '@shared/utils/isInIframe';

export const useFetchCoupleStoryData = (eventHandle: string, skip?: boolean) => {
  const { isAdmin } = useEventUserRole();
  const isPreviewing = isInIframe();
  const isSsrEnabled = useIsCurrentPageSsrFetchEnabled(eventHandle, 'story');

  const { data, loading } = useGetGuestsiteCoupleStoryAndQandasQuery({
    variables: { eventHandle, isAdminDashboard: isPreviewing && isAdmin },
    batchMode: 'fast',
    fetchPolicy: 'cache-and-network',
    ssr: isSsrEnabled,
    skip,
  });

  return { data, loading };
};
